const API_URL = import.meta.env.VITE_GETSIGN_API_URL;
const API_URL_V2 = import.meta.env.VITE_GETSIGN_API_URL_V2;

const BASE_API_URL = import.meta.env.VITE_GETSIGN_BASE_API_URL;
const API_URL_V3 = `${BASE_API_URL}/api/v3`;

export const getFile = async (id, itemId) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(`${API_URL}/files/get-file/${id}?itemId=${itemId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
  });

  if (!res.ok) {
    return { status: res.status, ...(await res.json()) };
  }
  const response = await res.json();
  return response;
};

export const getFileForAdhoc = async ({ envelopeId, assetId }) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(
    `${API_URL_V2}/adhoc/get-file/${envelopeId}/${assetId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
    },
  );

  if (!res.ok) {
    return { status: res.status, ...(await res.json()) };
  }

  const response = await res.json();
  return response;
};

export const getAttachedFilesFromEnvelope = async (envelopeId) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(
    `${API_URL_V2}/envelope/attached-files/${envelopeId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
    },
  );

  if (!res.ok) {
    return { status: res.status, ...(await res.json()) };
  }
  const response = await res.json();
  return response;
};

export const getAttachedFilesForAdhoc = async (envelopeId) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(`${API_URL_V2}/adhoc/get-files/${envelopeId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
  });

  if (!res.ok) {
    return { status: res.status, ...(await res.json()) };
  }
  const response = await res.json();
  return response;
};

export const getSignersSettings = async (envelopeId, itemId) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(
    `${API_URL_V2}/envelope-signers/get-signers/${envelopeId}/${itemId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
    },
  );

  return res.json();
};

export const getFileDetails = async (id) => {
  const res = await fetch(`${API_URL}/files/load-file-details/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.json();
};

export const getAllFileDetails = async (envelopeId) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const res = await fetch(`${API_URL_V2}/envelope/${envelopeId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      sessionToken,
    },
  });

  return res.json();
};

export const getFileForSigner = async (id, itemId) => {
  try {
    const res = await fetch(
      `${API_URL}/files/file-for-signer/${itemId}/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const addFormFields = async (payload) => {
  try {
    const {
      envelope_id,
      item_id,
      signer_order_settings = [],
      placeholders,
      isV3,
    } = payload;
    const sessionToken = localStorage.getItem('sessionToken');
    const api = isV3
      ? `${API_URL_V3}/files/map-placeholders`
      : `${API_URL_V2}/envelope/map-placeholder/${envelope_id}/${item_id}`;
    const postData = {
      placeholders,
      ...(isV3
        ? {
            envelopeId: envelope_id,
            itemId: Number(item_id),
            signerOrderSettings: signer_order_settings,
          }
        : { signer_order_settings }),
    };
    const res = await fetch(api, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: {
        'Content-Type': 'application/json',
        sessionToken,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      const error = new Error('API Error');
      error.status = res.status;
      error.data = data;
      throw error;
    }

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const mapTemplatePlaceholders = async (payload) => {
  try {
    const {
      templateId,
      signer_order_settings = [],
      placeholders,
      isV3 = false,
    } = payload;
    const sessionToken = localStorage.getItem('sessionToken');

    const baseUrl = isV3 ? API_URL_V3 : API_URL_V2;
    const res = await fetch(
      `${baseUrl}/template-gallery/map-template-placeholder/${templateId}`,
      {
        method: 'POST',
        body: JSON.stringify({
          signer_order_settings,
          placeholders,
        }),
        headers: {
          'Content-Type': 'application/json',
          sessionToken,
        },
      },
    );

    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const addFormFieldsForGenerate = async (payload) => {
  const {
    id,
    fields,
    signers_settings = [],
    item_id,
    pages_added_by_users,
  } = payload;
  const res = await fetch(`${API_URL}/files/add-form-fields/${id}/${item_id}`, {
    method: 'POST',
    body: JSON.stringify({
      fields,
      signers_settings,
      pages_added_by_users,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.json();
};

export const signDocument = async (payload) => {
  const { itemId, body, fileHistoryId } = payload;
  const api = `${API_URL_V2}/signing-flow/sign/${itemId}/${fileHistoryId}`;
  const res = await fetch(api, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.json();
};

export const getFileForReceiver = async (id, itemId) => {
  try {
    const res = await fetch(
      `${API_URL}/files/file-for-receiver/${itemId}/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const getFileForSender = async (id, itemId) => {
  try {
    const res = await fetch(
      `${API_URL}/files/file-for-sender/${itemId}/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const viewFile = async ({
  itemId,
  fileHistoryId,
  botTrapData,
}) => {
  try {
    const res = await fetch(
      `${API_URL_V2}/signing-flow/view-document/${itemId}/${fileHistoryId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ botTrapData }),
      },
    );
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const downloadContract = async (id) => {
  try {
    const res = await fetch(`${API_URL}/files/download/${id}`);
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const downloadContractV2 = async (fileHistoryId, fileId) => {
  try {
    const res = await fetch(
      `${API_URL_V2}/file/download/${fileHistoryId}/${fileId}`,
    );
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const generateFilePreview = async ({ fileId, itemId, envelopeId }) => {
  const sessionToken = localStorage.getItem('sessionToken');
  try {
    const res = await fetch(
      `${API_URL_V2}/file/generate-preview/${envelopeId}/${itemId}/${fileId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          sessionToken: sessionToken,
        },
      },
    );
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const generateTemplatePreview = async ({
  fileId,
  itemId,
  templateId,
}) => {
  const sessionToken = localStorage.getItem('sessionToken');
  try {
    const res = await fetch(
      `${API_URL_V2}/file/generate-template-preview/${templateId}/${itemId}/${fileId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          sessionToken: sessionToken,
        },
      },
    );
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const generateRealtimeFilePreviewForGenerateFlow = async (
  fileId,
  itemId,
  placeholders,
) => {
  try {
    const sessionToken = localStorage.getItem('sessionToken');
    const res = await fetch(
      `${API_URL}/files/generate-realtime-preview/${itemId}/${fileId}`,
      {
        method: 'POST',
        body: JSON.stringify({ placeholders }),
        headers: {
          'Content-Type': 'application/json',
          sessionToken: sessionToken,
        },
      },
    );
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const generateRealtimeFilePreview = async (
  envelopeId,
  fileId,
  itemId,
  placeholders,
) => {
  try {
    const sessionToken = localStorage.getItem('sessionToken');
    const res = await fetch(
      `${API_URL_V2}/file/generate-realtime-preview/${envelopeId}/${itemId}/${fileId}`,
      {
        method: 'POST',
        body: JSON.stringify({ placeholders }),
        headers: {
          'Content-Type': 'application/json',
          sessionToken: sessionToken,
        },
      },
    );
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const getFileHistory = async ({ itemId, envelopeId }) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(
    `${API_URL_V2}/envelope/history/${envelopeId}/${itemId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
    },
  );
  const response = await res.json();
  return response;
};

export const sendOrResendFileToReceiver = async (payload) => {
  const { itemId, id } = payload;
  const sessionToken = localStorage.getItem('sessionToken');

  return fetch(`${API_URL_V2}/signing-flow/send-envelope/${itemId}/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
  });
};

export const resendFileToReceiver = async (payload) => {
  const { itemId, id } = payload;
  const sessionToken = localStorage.getItem('sessionToken');

  return fetch(`${API_URL}/signer/resend-mail/${itemId}/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
  });
};

export const hasEnforcedOtp = async (fileHistoryId) => {
  const sessionToken = localStorage.getItem('sessionToken');
  return fetch(`${API_URL_V2}/otp/has-otp-enforced/${fileHistoryId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
  }).then((res) => res.json());
};

export const sendOtpVerification = async ({
  fileHistoryId,
  isResend = false,
}) => {
  return fetch(`${API_URL_V2}/otp/send-otp/${fileHistoryId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      resend: isResend,
    }),
  }).then((res) => res.json());
};

export const verifyOtp = async (code, fileHistoryId) => {
  return fetch(`${API_URL_V2}/otp/verify-otp/${fileHistoryId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      code,
    }),
  }).then((res) => res.json());
};

export const uploadImageInS3Bucket = async (formData) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const res = await fetch(`${API_URL}/files/standard-field-images/upload`, {
    method: 'POST',
    headers: {
      sessionToken: sessionToken,
    },
    body: formData,
  });
  const response = await res.json();
  return response;
};

export const removeImageFromS3Bucket = async (imageId) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const res = await fetch(
    `${API_URL}/files/standard-field-images/delete?s3Key=${imageId}`,
    {
      method: 'DELETE',
      headers: {
        sessionToken: sessionToken,
      },
    },
  );
  const response = await res.json();
  return response;
};

export const fetchImageFromS3Bucket = async (imageId) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const response = await fetch(
    `${API_URL}/files/standard-field-images?s3Key=${imageId}`,
    {
      method: 'GET',
      headers: {
        sessionToken: sessionToken,
      },
    },
  );
  const data = await response.json();
  return data.url;
};

export const updatePDF = async ({
  file,
  fileData,
  isTemporaryFile,
  fileHasBeenUpdated,
}) => {
  try {
    const sessionToken = localStorage.getItem('sessionToken');
    const res = await fetch(`${API_URL}/files/update-file`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
      body: JSON.stringify({
        file,
        file_name: fileData.file_name,
        board_id: fileData.board_id,
        account_id: fileData.account_id,
        file_id: fileData.id,
        is_temporary_file: isTemporaryFile,
        is_file_updated: fileHasBeenUpdated,
      }),
    });
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const declineSignatureRequest = async ({ id, itemId, message }) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(
    `${API_URL_V2}/signing-flow/decline-signature/${itemId}/${id}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
      body: JSON.stringify({ message }),
    },
  );

  return res.json();
};

export const shortLinkRedirect = async (shortId) => {
  const res = await fetch(`${API_URL}/files/short-redirect/${shortId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.json();
};

export const getDefaultLanguage = async (id) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const response = await fetch(
    `${API_URL_V2}/envelope/default-language/${id}`,
    {
      method: 'GET',
      headers: {
        sessionToken: sessionToken,
      },
    },
  );
  return response.json();
};

export const getSigningFlowAttachedFiles = async ({ fileHistoryId }) => {
  const response = await fetch(
    `${API_URL_V2}/signing-flow/files-for-signer/${fileHistoryId}`,
    {
      method: 'GET',
    },
  );
  return response.json();
};

export const getSigningFlowIndividualFileDetails = async ({
  fileHistoryId,
  fileDetailId,
}) => {
  const response = await fetch(
    `${API_URL_V2}/signing-flow/attached-file/${fileHistoryId}/${fileDetailId}`,
    {
      method: 'GET',
    },
  );
  const res = await response.json();
  return res.data;
};

export const checkReadyToSend = async ({ envelopeId, itemId }) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const response = await fetch(
    `${API_URL_V2}/signing-flow/document-presend-check/${itemId}/${envelopeId}`,
    {
      method: 'GET',
      headers: {
        sessionToken: sessionToken,
      },
    },
  );
  const res = await response.json();

  if (res.message) {
    return {
      message: res?.message,
    };
  } else {
    return {
      receiverSigFields: !res?.ok,
    };
  }
};

export const saveAdhocWordFile = async (html, assetId, envelopeId, itemId) => {
  try {
    const sessionToken = localStorage.getItem('sessionToken');

    const res = await fetch(
      `${API_URL_V2}/file/save-adhoc-ckeditor/${envelopeId}/${itemId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          sessionToken: sessionToken,
        },
        body: JSON.stringify({ html, assetId }),
      },
    );
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const saveWordFile = async (html, fileId) => {
  try {
    const sessionToken = localStorage.getItem('sessionToken');

    const res = await fetch(`${API_URL_V2}/file/save-ckeditor/${fileId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
      body: JSON.stringify({ html }),
    });
    return res.json();
  } catch (error) {
    console.error(error);
  }
};

export const getWordFile = async ({ fileId, isAdhoc, envelopeId }) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const api = isAdhoc
    ? `${API_URL_V2}/adhoc/get-file/${envelopeId}/${fileId}?fileType=word`
    : `${API_URL}/files/get-file/${fileId}?fileType=word`;

  const res = await fetch(api, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
  });
  const response = await res.json();
  return response;
};

export const fetchPreviewData = async ({
  itemId,
  html,
  fileId,
  tempSubItemConfigs = [],
}) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const api = `${API_URL_V2}/file/preview-ck-editor/${itemId}/${fileId}`;
  const res = await fetch(api, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
    body: JSON.stringify({ html, tempSubItemConfigs }),
  });
  const response = await res.json();
  return response;
};

export const fetchAdhocPreviewData = async ({
  itemId,
  envelopeId,
  html,
  fileId,
  tempSubItemConfigs = [],
}) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const api = `${API_URL_V2}/file/adhoc/preview-ck-editor/${envelopeId}/${fileId}/${itemId}`;
  const res = await fetch(api, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
    body: JSON.stringify({ html, tempSubItemConfigs }),
  });
  const response = await res.json();
  return response;
};
